
    <div class="row">
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="nombre" [(ngModel)]="centroSaludCercano.nombre" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="direccion" [(ngModel)]="centroSaludCercano.direccion" [disabled]="readonly" ></textarea>
        </div>
        <div class="col-sm-4">
            <textarea class="text-area-observacion-nivel" name="telefono" [(ngModel)]="centroSaludCercano.telefono" [disabled]="readonly" ></textarea>
        </div>
    </div>
